// extracted by mini-css-extract-plugin
export var createdDate = "_k5-1";
export var divider = "_k5-2";
export var headerDivider = "_k5-3";
export var messagesCard = "_k5-0";
export var messagesContainer = "_k5-7";
export var messagesContainerWrapper = "_k5-4";
export var pointerCapturingButtonBoxes = "_k5-a";
export var showLeftPanelButton = "_k5-9";
export var showMoreButton = "_k5-c";
export var showMoreButtonContainer = "_k5-b";
export var summaryTitle = "_k5-6";
export var systemMessageCardWrapper = "_k5-d";
export var topButtons = "_k5-8";
export var withPadding = "_k5-5";